/* 2026-06-26 · Hover-reveal buy bar (Marian).
   On hover-capable (desktop) devices, relocate each card's existing price + add-to-cart
   row (.jcl-card__buy, with its AJAX form intact) INTO the product image (.jcl-card__media)
   so it can slide up over the lower edge on hover (CSS handles the reveal). Renderer-agnostic:
   works for every .jcl-card (collection, sets rail, accessories, bestsellers) with no Liquid
   change. On touch devices we do nothing, so the buy row stays in the body (normal mobile UX). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  function place(root) {
    (root || document).querySelectorAll('.jcl-card').forEach(function (card) {
      var media = card.querySelector(':scope > .jcl-card__media') || card.querySelector('.jcl-card__media');
      var buy = card.querySelector('.jcl-card__buy');
      if (media && buy && buy.parentElement !== media) media.appendChild(buy);
    });
  }

  function init() {
    place(document);
    // Cover lazily-injected cards (pagination, quick-views, theme editor reloads).
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.jcl-card')) place(n.parentNode);
            else if (n.querySelector && n.querySelector('.jcl-card')) place(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { place(document); });
})();
